function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.7 15.3C14.8444 15.4926 14.9146 15.7308 14.8975 15.9709C14.8804 16.211 14.7773 16.4369 14.6071 16.6071C14.4369 16.7773 14.211 16.8804 13.9709 16.8975C13.7308 16.9146 13.4926 16.8444 13.3 16.7L9.30002 12.7C9.11679 12.5131 9.01416 12.2618 9.01416 12C9.01416 11.7383 9.11679 11.4869 9.30002 11.3L13.3 7.30001C13.4926 7.15558 13.7308 7.08546 13.9709 7.10252C14.211 7.11959 14.4369 7.22269 14.6071 7.3929C14.7773 7.56311 14.8804 7.78901 14.8975 8.02912C14.9146 8.26923 14.8444 8.50744 14.7 8.70001L11.42 12L14.72 15.3H14.7Z"
});

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left.1e3c26a4.svg";
export { ForwardRef as ReactComponent };